import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; 
import { Role } from '../types';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { loggedIn, role } = useAuth();

  if (!loggedIn || role === Role.USER) {

    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
